// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1rVpT","title":"ClientInsurance_title__2FdIx","itemText":"ClientInsurance_itemText__cwhVu"};